import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import withReactContent from "sweetalert2-react-content";
import { getBomStatusAPI } from "actions/bomActions";
import { getGroupedProducts } from "utils/bomUtils";
import PageWrapper from "components/PageWrapper";
import BomConsolidatedView from "components/bom/BomConsolidatedView";
import LoadingComponent from "components/LoadingComponent";
import Swal from "sweetalert2";
import { useAuth } from "AuthContext";
import { END_POINT } from "constants/apiConstant";
import { formatManufacturerName } from "utils/stringUtils";
import { getActiveDistributor } from "actions/distributorActions";
import { All_DISTRIBUTOR } from "constants/appConstant";
// import { digikeyResponse } from "./data1";

const MySwal = withReactContent(Swal);
const BOM_STATUS_POLL_DELAY_MS = 4000;
const MAX_POLL_WHEN_LARGE = 12; // when bom_items.length > 50
const MAX_POLL_WHEN_SMALL = 4; // when bom_items.length <= 50

const BomToolPage = () => {
  const { id } = useParams();
  const { addToCart } = useAuth();
  const dispatch = useDispatch();
  const [renderCount, setRenderCount] = useState(0);
  const [activeDistributors, setActiveDistributors] = useState([]);
  const [selectedDistributor, setSelectedDistributor] = useState({});
  const pollAttemptsRef = useRef(0);
  const pollTimerRef = useRef(null);
  const [pollComplete, setPollComplete] = useState(false);
  const [pollAttempts, setPollAttempts] = useState(0);
  const [maxPollCount, setMaxPollCount] = useState(MAX_POLL_WHEN_SMALL);
  const [bomData, setBomData] = useState({
    loading: true,
    products: [],
    groupData: [],
    processedBom: [],
    totalBomCount: 0,
    noStockCount: [],
    processedBomCount: 0,
    pendingBomCount: 0,
    consolidatedView: true,
    notFoundProduct: [],
    distributorMin: [],
  });

  const mapQty = (array, qty) => {
    // if (!array.length) return [];
    return array.map((item) => {
      return { ...item, qty: qty };
    });
  };

  const onLoad = async ({ allowAutoPoll = false } = {}) => {
    const res = await getBomStatusAPI(id);
    // const res = digikeyResponse;
    console.log("BOM TOOL Response----->", { res });

    if (res.status) {
      const products = [];
      const multipleMPN = [];
      let totNotFound = 0;

      for (let i = 0; i < res.data.bom_items.length; i++) {
        const item = res.data.bom_items[i];
        const currentItemProducts = [];

        if (item.mouser) currentItemProducts.push(...mapQty(item.mouser, Number(item.qty)));
        if (item.digikey) currentItemProducts.push(...mapQty(item.digikey, Number(item.qty)));
        if (item.element14) currentItemProducts.push(...mapQty(item.element14, Number(item.qty)));
        if (item.tme) currentItemProducts.push(...mapQty(item.tme, Number(item.qty)));

        if (item.digikeyCount == 0 && item.mouserCount == 0 && item.element14Count == 0 && item.tmeCount == 0) {
          totNotFound = totNotFound + 1;
        }
        const exactMatch = currentItemProducts.filter((product) => product.MPNMatchFlag);
        // console.log({ exactMatch });

        if (
          exactMatch.length === 0 &&
          (item.digikeyCount > 0 || item.mouserCount > 0 || item.element14Count > 0 || item.tmeCount > 0)
        ) {
          multipleMPN.push(item.part_number);
        }
        products.push(...currentItemProducts);
      } // End of for loop

      const processedBom = res.data.bom_items.filter((bomItem) => bomItem.status == 'completed');

      const filteredMatchingProducts = products.filter((product) => product.MPNMatchFlag);

      const groupData = getGroupedProducts(filteredMatchingProducts, processedBom);

      let noStock = groupData?.filter(
        (group) =>
          group.availability == 0 ||
          group.availability == "" ||
          group.availability == "None" ||
          group.availability == "N/A",
      );


      const processedPartNo = products.map((product) => product.part_number);
      const allPartNo = processedBom.map((product) => product.part_number);
      const notFoundProductFillter = allPartNo.filter((item) => !processedPartNo.includes(item));
      let pendingCount = res.data.bom_items.length - processedBom.length;

      const multipleMpnProducts = filteredMatchingProducts.filter(
        (product) =>
          product.api_partner_part_number !== "N/A" &&
          !isEmpty(product.api_partner_part_number) &&
          !isEmpty(product.availability) &&
          product.availability !== "0" &&
          product.availability !== "None",
      );

      if (processedBom.length > 0) {
        setBomData({
          ...bomData,
          loading: false,
          bomUploadData: res.data.bom,
          products: products,
          groupData: groupData,
          processedBom: processedBom,
          totalBomCount: res.data.bom_items.length,
          noStockCount: noStock,
          processedBomCount: processedBom.length,
          bomItemsCount: res.data.bom_items.length,
          pendingBomCount: pendingCount,
          totalNotFound: totNotFound,
          notFoundProduct: notFoundProductFillter,
          distributorMin: res.data.distributorMin,
          bomItems: res.data.bom_items,
          multipleMPN: multipleMPN,
          multipleMpnProducts: multipleMpnProducts,
        });
      } else {
        setBomData({ ...bomData, products: products, groupData: groupData });
      }

      // Auto poll the bom status if the bom is not processed yet
      if (processedBom.length !== res.data.bom_items.length) {
        setTimeout(() => {
          onLoad({ allowAutoPoll: true });
        }, 5000);

        
      }
    }
  };

  const handleBomDataDownload = () => {
    window.open(`${END_POINT.BOM_DATA_DOWNLOAD}${id}`, "_blank");
  };

  const handleAddToCart = (product, isMultipleMPN = false) => {
    const cartProduct = {
      ...product,
      qty: parseInt(product.qty),
      required_qty: parseInt(product.required_qty) || parseInt(product.price.min_order),
      part_number: isMultipleMPN ? product.api_partner_part_number : product.part_number,
      manufacturer: formatManufacturerName(product.manufacturer),
    };
    // console.log({ cartProduct, isMultipleMPN });
    addToCart(cartProduct); // update the cart in the context
    MySwal.fire({
      title: "Success",
      html: `Product: <strong>${product.part_number}</strong> added to cart`,
      icon: "success",
    });
  };

  const handleBomRefresh = useCallback((opts = {}) => {
    const { fullPageLoader = true } = opts;
    if (!fullPageLoader) {
      onLoad({ allowAutoPoll: false });
      return;
    }
    setBomData((prevBomData) => ({ ...prevBomData, loading: true }));
    onLoad({ allowAutoPoll: false });
  }, []);

  const handleDistributorChange = useCallback(
    (partNumber, distributor, itemId) => {
      if (!distributor || distributor.trim() === "") {
        MySwal.fire({
          title: "Invalid Selection",
          html: "Please select a valid distributor",
          icon: "warning",
        });
        return false;
      }

      const selectedItem = bomData?.bomItems?.find(
        (item) => item.part_number === partNumber || item.id === itemId,
      );
      const distributorKey = distributor.trim().toLowerCase();
      const distributorProducts = Array.isArray(selectedItem?.[distributorKey])
        ? selectedItem[distributorKey]
        : [];

      const hasValidDistributorData = distributorProducts.some((product) => {
        const availability = product?.availability;
        return availability !== "" && availability !== 0 && availability !== "0";
      });

      if (distributorProducts.length === 0 || !hasValidDistributorData) {
        MySwal.fire({
          title: "No Data Found",
          html: `No data found for part number <strong>${partNumber}</strong> in <strong>${distributor}</strong> distributor.`,
          icon: "warning",
        });
        return false;
      }

      setBomData((prevBomData) => {
        if (!prevBomData.bomItems) return prevBomData;

        const updatedBomItems = prevBomData.bomItems.map((item) => {
          if (item.part_number === partNumber || item.id === itemId) {
            return {
              ...item,
              selected_distributor: distributor,
            };
          }
          return item;
        });

        return {
          ...prevBomData,
          bomItems: updatedBomItems,
        };
      });
      setSelectedDistributor((prev) => ({
        ...prev,
        [partNumber]: distributor,
      }));
      return true;
    },
    [bomData],
  );

  const getDistributors = async () => {
    const res = await getActiveDistributor();
    if (res?.status && res?.data) {
      const active = All_DISTRIBUTOR.filter(
        (d) => res.data[d.value] === true && d.isActive === true,
      );
      setActiveDistributors(active);
    }
  };

  useEffect(() => {
    getDistributors();
  }, []);

  useEffect(() => {
    if (id) {
      pollAttemptsRef.current = 0;
      setPollAttempts(0);
      setPollComplete(false);
      setMaxPollCount(MAX_POLL_WHEN_SMALL);
      if (pollTimerRef.current) {
        clearTimeout(pollTimerRef.current);
        pollTimerRef.current = null;
      }
      setBomData((prevBomData) => ({ ...prevBomData, loading: true }));
      onLoad({ allowAutoPoll: true });
    }
    return () => {
      if (pollTimerRef.current) {
        clearTimeout(pollTimerRef.current);
        pollTimerRef.current = null;
      }
    };
  }, [id]);

  return (
    <PageWrapper>
      {/* {bomData.loading && <LoadingComponent message="Loading..." />} */}
      <div className="flex items-center space-x-4 mb-6">
        <div className="flex flex-col gap-3">
          <h2 className="text-3xl font-bold text-[#1e293b]">BOM Tool</h2>
        </div>
      </div>
      <BomConsolidatedView
        bomData={bomData}
        handleAddToCart={handleAddToCart}
        bomRefresh={handleBomRefresh}
        handleBomDataDownload={handleBomDataDownload}
        onDistributorChange={handleDistributorChange}
        setRenderCount={setRenderCount}
        renderCount={renderCount}
        activeDistributors={activeDistributors}
        setSelectedDistributor={setSelectedDistributor}
        selectedDistributor={selectedDistributor}
        pollComplete={pollComplete}
        pollAttempts={pollAttempts}
        maxPollCount={maxPollCount}
      />
    </PageWrapper>
  );
};

export default BomToolPage;
